export function addItem(array: any[], item: any) {
  return array.concat(item);
}
export function removeItem(array: any[], item: any) {
  return array.filter((v) =>
    Array.isArray(item) ? !item.includes(v) : v !== item
  );
}
